import type { AccessBranch, AirportCode } from "@japangolmok/content";
import { ARRIVAL_CARD_STORE, deleteRecord, getAllRecords, getRecord, putRecord } from "./db";

export type ArrivalCard = {
  schemaVersion: 1;
  id: string;
  airport: AirportCode;
  city: string;
  branch: AccessBranch;
  sourceUrl: string;
  checkedAt: string;
  savedAt: string;
};

export function needsCardRefresh(checkedAt: string, now = Date.now()) {
  const checked = new Date(checkedAt).getTime();
  return !Number.isFinite(checked) || now - checked >= 72 * 60 * 60 * 1000;
}

export async function saveCard(card: ArrivalCard) {
  await putRecord(ARRIVAL_CARD_STORE, card);
}

export async function listCards() {
  const cards = await getAllRecords<ArrivalCard>(ARRIVAL_CARD_STORE);
  return cards.sort((a, b) => b.savedAt.localeCompare(a.savedAt));
}

export async function getCard(id: string) {
  return getRecord<ArrivalCard>(ARRIVAL_CARD_STORE, id);
}

export function serializeCard(card: ArrivalCard) {
  return `${JSON.stringify(card, null, 2)}\n`;
}

export async function removeCard(id: string) {
  await deleteRecord(ARRIVAL_CARD_STORE, id);
}
